const TEST_ACCOUNTS = {
  ALREADY_EXISTS: 'Test account email already exists.',
  INVALID_ACTION: 'Invalid test account form action passed, please try again.',
  ADDED: 'Test account added successfully.',
  UPDATED: 'Test account updated successfully.',
  DELETED: 'Test account deleted successfully.',
  SETTING_UPDATED: 'Test accounts setting updated successfully.',
  INVALID_EMAIL: 'Please add a valid email to add new test account.',
  EXISTS: 'Test account already exists, please try a different user.',
  NOT_FOUND: 'Test account not found, please try again.',
  MUST_BE_MANAGER: 'Internal tester should be a manager account.',
} as const;

export default TEST_ACCOUNTS;
